import api from './api';

export const getsArticulo = async (params = {}) => {
    const res = await api.get('/Inventario/GetsArticulo', { params });
    return res.data;
};

export const getArticuloById = async (id) => {
    const res = await api.get('/Inventario/GetArticuloById', { params: { id } });
    return res.data;
};

export const getArticuloByCodigoBarras = async (codigoBarras) => {
    const res = await api.get('/Inventario/GetArticuloByCodigoBarras', { params: { codigoBarras } });
    return res.data;
};

export const postArticulo = async (model) => {
    const res = await api.post('/Inventario/PostArticulo', model);
    return res.data?.data;
};

export const cambiarEstadoArticulo = async (idArticulo, activo) => {
    const res = await api.post(`/Inventario/CambiarEstadoArticulo?idArticulo=${idArticulo}&activo=${activo}`);
    return res.data?.data;
};

export const getsCategoriasArticulo = async () => {
    const res = await api.get('/Inventario/GetsCategoriasArticulo');
    return res.data;
};

export const getsTiposMovimientoKardex = async () => {
    const res = await api.get('/Inventario/GetsTiposMovimientoKardex');
    return res.data;
};

export const getsKardex = async (params = {}) => {
    const res = await api.get('/Inventario/GetsKardex', { params });
    return res.data;
};

export const registrarMovimientoKardex = async (model, requiereAprobacion = false) => {
    const res = await api.post(`/Inventario/RegistrarMovimientoKardex?requiereAprobacion=${requiereAprobacion}`, model);
    return res.data?.data;
};

export const aprobarMovimientoKardex = async (idKardex, observaciones = '') => {
    const res = await api.post(`/Inventario/AprobarMovimientoKardex?idKardex=${idKardex}&observaciones=${encodeURIComponent(observaciones)}`);
    return res.data?.data;
};

export const rechazarMovimientoKardex = async (idKardex, motivo = '') => {
    const res = await api.post(`/Inventario/RechazarMovimientoKardex?idKardex=${idKardex}&motivo=${encodeURIComponent(motivo)}`);
    return res.data?.data;
};

export const anularMovimientoKardex = async (idKardex, motivo = '') => {
    const res = await api.post(`/Inventario/AnularMovimientoKardex?idKardex=${idKardex}&motivo=${encodeURIComponent(motivo)}`);
    return res.data?.data;
};

const inventarioService = {
    getsArticulo,
    getArticuloById,
    getArticuloByCodigoBarras,
    postArticulo,
    cambiarEstadoArticulo,
    getsCategoriasArticulo,
    getsTiposMovimientoKardex,
    getsKardex,
    registrarMovimientoKardex,
    aprobarMovimientoKardex,
    rechazarMovimientoKardex,
    anularMovimientoKardex
};

export default inventarioService;
